// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xGoogleAnalyticsState } from "@awc/App/Widgets/GoogleAnalyticsConnector/Store/Reducers";
import { getDataLayer } from "@awc/App/Widgets/GoogleAnalyticsConnector/Utilities/DataLayer";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    chain,
    DispatchResetOrderApprovals,
    SendTracking,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";

export const XngGaSendTracking: typeof DispatchResetOrderApprovals = props => {
    const state = props.getState() as xGoogleAnalyticsState;
    const updatedCart = { ...props.cartToUpdate, orderNumber: props.apiResult.cart.orderNumber };
    const session = getSession(props.getState());
    const dataLayer = getDataLayer();

    if (!dataLayer) {
        return;
    }

    const { apiResult } = props;
    if (state.xGoogleAnalytics.transactionCompleteEvent) {
        const googleAnalyticsDataa = {
            event: state.xGoogleAnalytics.transactionCompleteEventName,
            transactionId: apiResult?.cart?.orderNumber,
            transactionAffiliation: apiResult?.billTo?.companyName,
            transactionTotal: apiResult?.cart?.orderGrandTotal,
            transactionTax: apiResult?.cart?.totalTax,
            transactionShipping: apiResult?.cart?.shippingAndHandling,
            customerIndustry: session?.properties?.customerIndustry,
            transactionProducts: updatedCart.cartLines?.map((cartLine, idx) => ({
                sku: cartLine.erpNumber,
                name: cartLine.shortDescription,
                price: cartLine.pricing?.unitNetPrice,
                quantity: cartLine.qtyOrdered,
                category: state.xGoogleAnalytics.includeProductCategory
                    ? cartLine.properties?.["l1Category"] : undefined,
            })),
        };

        dataLayer.push(googleAnalyticsDataa);
    }

    if (state.xGoogleAnalytics.purchaseEvent) {
        const googleAnalyticsData = {
            event: state.xGoogleAnalytics.purchaseEventName,
            ecommarce: {
                purchas: {
                    actionField: {
                        id: apiResult.cart.orderNumber,
                        affiliation: apiResult.billTo?.companyName,
                        customerIndustry: session?.properties?.customerIndustry,
                        revenue: apiResult.cart.orderGrandTotal,
                        tax: apiResult.cart.totalTax,
                        shipping: apiResult.cart.shippingAndHandling,
                        action: "purchase",
                    },
                    products: [],
                }
            },
        };

        dataLayer.push(googleAnalyticsData);
    }
};

// XNG-Change: Match Classic
replaceInChain(chain, SendTracking, XngGaSendTracking);
